module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp12_8003.c06f3198.png";